import React, { useState, useEffect } from 'react';
import { FiFileText } from 'react-icons/fi';
import { db, storage } from '../../firebase'; // Ajusta la ruta
import './FacturasADMIN.css';
import {
  collection,
  addDoc,
  query,
  where,
  onSnapshot,
  doc,
  deleteDoc,
  orderBy,
  serverTimestamp
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";

const FacturasADMIN = () => {
  const [clientes, setClientes] = useState([]);
  const [facturas, setFacturas] = useState([]);
  const [clienteSeleccionado, setClienteSeleccionado] = useState('');
  const [archivo, setArchivo] = useState(null);
  const [subiendo, setSubiendo] = useState(false);
  const [busquedaCliente, setBusquedaCliente] = useState('');

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "clientes"), snapshot => {
      const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setClientes(data);
      if (!clienteSeleccionado && data.length > 0) setClienteSeleccionado(data[0].id);
    });
    return () => unsub();
  }, [clienteSeleccionado]);

  useEffect(() => {
    if (!clienteSeleccionado) return setFacturas([]);
    const q = query(
      collection(db, "facturas"),
      where("clienteId", "==", clienteSeleccionado),
      orderBy("fecha", "desc")
    );
    const unsub = onSnapshot(q, snapshot => {
      const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setFacturas(data);
    });
    return () => unsub();
  }, [clienteSeleccionado]);

  const handleArchivoChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type !== "application/pdf") {
      alert("Solo puedes subir archivos PDF");
      return;
    }
    setArchivo(file);
  };

  const subirFactura = async () => {
    if (!archivo || !clienteSeleccionado) return alert("Selecciona cliente y archivo");
    setSubiendo(true);

    try {
      const archivoRef = ref(storage, `facturas/${clienteSeleccionado}/${Date.now()}_${archivo.name}`);
      await uploadBytes(archivoRef, archivo);

      const url = await getDownloadURL(archivoRef);

      await addDoc(collection(db, "facturas"), {
        clienteId: clienteSeleccionado,
        nombreArchivo: archivo.name,
        url,
        fecha: serverTimestamp()
      });

      alert("Factura subida con éxito");
      setArchivo(null);
      document.getElementById("inputArchivo").value = "";
    } catch (error) {
      alert("Error al subir factura: " + error.message);
    } finally {
      setSubiendo(false);
    }
  };

  const borrarFactura = async (factura) => {
    if (!window.confirm(`¿Seguro quieres borrar la factura "${factura.nombreArchivo}"?`)) return;

    try {
      const archivoRef = ref(storage, factura.url);
      await deleteObject(archivoRef).catch(() => {});

      await deleteDoc(doc(db, "facturas", factura.id));

      alert("Factura borrada");
    } catch (error) {
      alert("Error al borrar factura: " + error.message);
    }
  };

  // Filtrar clientes por nombre o email
  const clientesFiltrados = clientes.filter(c =>
    c.nombre?.toLowerCase().includes(busquedaCliente.toLowerCase()) ||
    c.email?.toLowerCase().includes(busquedaCliente.toLowerCase())
  );

  return (
    <div className="p-6 bg-gray-50 rounded shadow-md max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-6 text-blue-700 flex items-center gap-2">
        <FiFileText size={32} />
        Gestión avanzada de Facturas
      </h1>

      <label className="block mb-2 font-semibold" htmlFor="buscarCliente">Buscar cliente:</label>
      <input
        id="buscarCliente"
        type="text"
        placeholder="Busca cliente por nombre o email..."
        className="w-full p-3 mb-4 border border-gray-300 rounded"
        value={busquedaCliente}
        onChange={e => setBusquedaCliente(e.target.value)}
      />

      <label className="block mb-2 font-semibold" htmlFor="selectCliente">Seleccionar cliente:</label>
      <select
        id="selectCliente"
        className="w-full p-3 mb-6 border border-gray-300 rounded"
        value={clienteSeleccionado}
        onChange={e => setClienteSeleccionado(e.target.value)}
      >
        {clientesFiltrados.map(c => (
          <option key={c.id} value={c.id}>
            {c.nombre} ({c.email || 'sin correo'})
          </option>
        ))}
      </select>

      <label className="block mb-2 font-semibold" htmlFor="inputArchivo">Subir factura (PDF):</label>
      <input
        id="inputArchivo"
        type="file"
        accept="application/pdf"
        onChange={handleArchivoChange}
        className="mb-4"
      />
      <button
        disabled={!archivo || subiendo}
        onClick={subirFactura}
        className={`btnPrimary ${(!archivo || subiendo) ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        {subiendo ? 'Subiendo...' : 'Subir factura'}
      </button>

      <h2 className="text-2xl font-bold mt-10 mb-4 text-blue-600">
        Facturas de {clientes.find(c => c.id === clienteSeleccionado)?.nombre || ''}
      </h2>

      {facturas.length === 0 ? (
        <p className="text-gray-500">No hay facturas para este cliente.</p>
      ) : (
        <table className="min-w-full bg-white rounded shadow">
          <thead>
            <tr className="bg-blue-600 text-white text-left">
              <th className="py-3 px-6">Archivo</th>
              <th className="py-3 px-6">Fecha subida</th>
              <th className="py-3 px-6">Descargar</th>
              <th className="py-3 px-6">Eliminar</th>
            </tr>
          </thead>
          <tbody>
            {facturas.map(factura => (
              <tr key={factura.id} className="border-b hover:bg-gray-100 transition-colors">
                <td className="py-3 px-6 font-semibold">{factura.nombreArchivo}</td>
                <td className="py-3 px-6">{factura.fecha?.toDate ? factura.fecha.toDate().toLocaleString() : '...'}</td>
                <td className="py-3 px-6">
                  <a href={factura.url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    Descargar
                  </a>
                </td>
                <td className="py-3 px-6">
                  <button
                    onClick={() => borrarFactura(factura)}
                    className="text-red-600 hover:underline"
                    title="Borrar factura"
                  >
                    Eliminar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default FacturasADMIN;
